import { StyledSpinner, Wrapper } from "./styled";

export const Loading = () => (
  <Wrapper>
    Please wait, project are&nbsp;being&nbsp;loaded...
    <StyledSpinner />
  </Wrapper>
);
